import React from 'react';
// import { Carousel } from 'react-responsive-carousel';
import Carousel from '../carousel/carousel';
import Card from '../post/card';






class Mantra1_5 extends React.Component {
    render() {
        return (
            <div>
                <img src="/assets/img/home.png" className="img-fluid home_img" alt="" />
                {/* <Carousel /> */}
                <div className="card_content_bg">
                    <div className="container">
                        <button type="button" className="preview_btn">
                        <div className="m3_p_img_prev">
                            <span>Preview</span>
                        </div>
                        </button>
                        <div className="img_frame_flex">

                            <div className="card_content">
                                <img src="/assets/img/img-1.jpg" className="img-fluid" alt="" />
                                <h4>Manish Vajpayee</h4>
                                <h5>Republic Day</h5>
                                {/* <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1488</span></h6> */}
                            </div>

                            <div className="img_frame2">
                                <ul>
                                    <li>
                                        <img src="/assets/img/cross.png" className="img-fluid" alt="" />
                                    </li>
                                    <li>
                                        <img src="/assets/img/refresh.png" className="img-fluid" alt="" />
                                    </li>
                                    <li>
                                        <img src="/assets/img/check2.png" className="img-fluid" alt="" />
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="preview_btn2">
                            <a href="#">Share</a>
                        </div>
                    </div>
                </div>
                <Card />
            </div>

        )
    }
}

export default Mantra1_5;